import React, { useState, useEffect } from 'react';
import { getInteractionCategories, createInteractionCategory, deleteInteractionCategory } from '../../api';
import { useNotification } from '../../context/NotificationContext';

const InteractionCategoryManager = ({ configId }) => {
  const [categories, setCategories] = useState([]);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [showForm, setShowForm] = useState(false);
  const { showNotification } = useNotification();

  const fetchCategories = async () => {
    try {
      const data = await getInteractionCategories(configId);
      setCategories(data);
    } catch (error) {
      console.error('Error fetching interaction categories:', error);
    }
  };

  useEffect(() => {
    if (configId) {
      fetchCategories();
    }
  }, [configId]);

  const handleAddCategory = async (e) => {
    e.preventDefault();
    try {
      const data = {
        configuration_id: parseInt(configId),
        display_name: newCategoryName,
        description: ''
      };
      await createInteractionCategory(configId, data);
      setNewCategoryName('');
      setShowForm(false);
      await fetchCategories();
      showNotification('Category added successfully!', 'success');
    } catch (error) {
      showNotification(`Error adding category: ${error.message}`, 'error');
      console.error('Error adding interaction category:', error);
    }
  };

  const handleDeleteCategory = async (id) => {
    if (window.confirm('Are you sure you want to delete this category?')) {
      try {
        await deleteInteractionCategory(id);
        await fetchCategories();
        showNotification('Category deleted successfully!', 'success');
      } catch (error) {
        showNotification(`Error deleting category: ${error.message}`, 'error');
        console.error('Error deleting interaction category:', error);
      }
    }
  };

  return (
    <div className="section-card">
      <div className="section-header">
        <h2 className="text-xl font-semibold">Interaction Categories</h2>
      </div>
      <div className="section-content p-8">
        <div className="table-wrapper">
          <table className="data-table w-full">
            <thead>
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Display Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {categories.map((category) => (
                <tr key={category.id}>
                  <td className="px-6 py-4 whitespace-nowrap">{category.display_name || '-'}</td>
                  <td className="px-6 py-4 whitespace-nowrap">{category.description || '-'}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <button onClick={() => handleDeleteCategory(category.id)} className="text-red-600 hover:text-red-900">
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <button onClick={() => setShowForm(!showForm)} className="add-button mt-4">
          {showForm ? 'Cancel' : 'Add New Category'}
        </button>
        {showForm && (
          <form onSubmit={handleAddCategory} className="mt-4 p-4 bg-gray-50 rounded-lg">
            <div className="flex items-center space-x-2">
            <input
              type="text"
              value={newCategoryName}
              onChange={(e) => setNewCategoryName(e.target.value)}
              placeholder="Category Display Name"
              className="form-input flex-grow"
              required
            />
            <button type="submit" className="action-button bg-purple-600 text-white px-4 py-2 rounded-lg">Add</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default InteractionCategoryManager; 